import { NavLink } from "react-router-dom";

export interface MenuNavLink {
    to: string;
    label: string;
}

interface MenuNavProps {
    links: MenuNavLink[];
}

export const MenuNav = ({ links }: MenuNavProps) => {
    const itemClass = "border-l border-secondary rounded-none px-2";
    const activeItemClass = "border-b-3 border-b-secondary rounded-none";

    return (
        <div className="navbar-center text-secondary mt-2">
            <ul className="menu menu-horizontal text-lg rounded-none">
                {links.map((link, index) => (
                    <li
                        key={link.to}
                        className={`${itemClass}${
                            index === links.length - 1 ? " border-r" : ""
                        }`}
                    >
                        <NavLink
                            to={link.to}
                            className={({ isActive }) =>
                                isActive ? activeItemClass : ""
                            }
                        >
                            {link.label}
                        </NavLink>
                    </li>
                ))}
            </ul>
        </div>
    );
};
